import React from "react";
import Typical from "react-typical";
import emailjs from "emailjs-com";

import BackgroundProfile from "./img/senura.jpg";
import "./home.css";

import HeaderBlock from "./HeaderBlock.component";
import GalleryComponent from "../GalleryComponent/gallery.component";
import Cv from "../cv/cv.component";

import IMG1 from "./img/1.jpg";
import IMG2 from "./img/2.jpg";
import IMG3 from "./img/3.jpg";

export default function HomePage() {
  function sendEmail(e) {
    e.preventDefault();
    emailjs
      .sendForm(
        "gmail",
        "template_kyp0rmp",
        e.target,
        "user_tDm48eLt2wR9dF6Cn5mki"
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Email has been sent");
          window.location = "/";
        },
        (error) => {
          console.log(error.text);
          alert("Error! Email has not been sent");
          window.location = "/";
        }
      );
  }

  return (
    <div className="HomePageComponent">
      {/* Modal  */}
      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Contact Me
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form onSubmit={sendEmail}>
                <div class="form-group">
                  <label for="exampleInputEmail1">Email</label>
                  <input
                    name="from_email"
                    type="email"
                    class="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="Enter Your Email"
                  />
                  <small id="emailHelp" class="form-text text-muted">
                    We'll never share your email with anyone else.
                  </small>
                </div>
                <div class="form-group">
                  <label for="exampleInputPassword1">Message</label>
                  <textarea
                    name="message"
                    class="form-control"
                    id="exampleInputPassword1"
                    placeholder="Enter Your Message"
                  ></textarea>
                </div>
                <button type="submit" class="btn btn-primary">
                  SEND
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* End of Modal  */}

      <main class="page lanidng-page">
        <HeaderBlock />

        <section class="portfolio-block photography">
          <div class="container">
            <div class="row no-gutters">
              <div
                class="col-md-6 col-lg-4 item zoom-on-hover"
                data-aos="fade-up"
                data-aos-delay="600"
                data-aos-duration="800"
              >
                <a href="#">
                  <img class="img-fluid image" src={IMG1} />
                </a>
              </div>
              <div
                class="col-md-6 col-lg-4 item zoom-on-hover"
                data-aos="fade-up"
                data-aos-delay="600"
                data-aos-duration="800"
              >
                <a href="#">
                  <img class="img-fluid image" src={IMG3} />
                </a>
              </div>
              <div
                class="col-md-6 col-lg-4 item zoom-on-hover"
                data-aos="fade-up"
                data-aos-delay="600"
                data-aos-duration="800"
              >
                <a href="#">
                  <img class="img-fluid image" src={IMG2} />
                </a>
              </div>
            </div>
          </div>
        </section>
        <section class="portfolio-block call-to-action">
          <div class="container">
            <div class="d-flex justify-content-center align-items-center content">
              <h3>Like what you see?</h3>
              <button
                class="btn btn-outline-primary btn-lg"
                type="button"
                data-toggle="modal"
                data-target="#exampleModal"
              >
                Contact Me
              </button>
            </div>
          </div>
        </section>
        <section
          class="portfolio-block skills"
          style={{ borderBottom: "none" }}
        >
          <div class="container">
            <div
              class="heading"
              data-aos="fade-up"
              data-aos-delay="400"
              data-aos-duration="500"
            >
              <h2>Special Skills</h2>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div
                  class="card special-skill-item border-0"
                  data-aos="zoom-in"
                  data-aos-delay="400"
                  data-aos-duration="500"
                >
                  <div class="card-header bg-transparent border-0">
                    <i class="icon fas fa-mobile-alt"></i>
                  </div>
                  <div class="card-body">
                    <h3 class="card-title">Mobile Development</h3>
                    <p class="card-text">
                      Develop user friendly android apps with latest
                      technologies according to your business requirements
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="card special-skill-item border-0"
                  data-aos="zoom-in"
                  data-aos-delay="400"
                  data-aos-duration="500"
                >
                  <div class="card-header bg-transparent border-0">
                    <i class="icon far fa-lightbulb"></i>
                  </div>
                  <div class="card-body">
                    <h3 class="card-title">IoT</h3>
                    <p class="card-text">
                       I help companies use the full potential of Internet of
                      Things and offer IoT development services for any industry
                      and vertical
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="card special-skill-item border-0"
                  data-aos="zoom-in"
                  data-aos-delay="400"
                  data-aos-duration="500"
                >
                  <div class="card-header bg-transparent border-0">
                    <i class="icon fab fa-internet-explorer"></i>
                  </div>
                  <div class="card-body">
                    <h3 class="card-title">Web Development</h3>
                    <p class="card-text">
                      Develop modern and creative websites that will help you
                      reach all of ur marketing
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <Cv />
        </section>

        <section>
          <GalleryComponent />
        </section>
      </main>
    </div>
  );
}
